import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { styled } from '@mui/system';
import { PROMETHEAN_TEXT, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_BLUE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_EYEBROW } from '../styles/typography/typography';
export var ROOT_PREFIX = 'EmbersThumsbRating';
export var ThumbContainer = styled('span')(_defineProperty({}, "&.".concat(ROOT_PREFIX, "-thumb"), _defineProperty(_defineProperty(_defineProperty({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  order: 0,
  columnGap: '2px',
  '&:focus-visible': {
    outline: "2px solid ".concat(PROMETHEAN_BLUE)
  }
}, "&:not(.".concat(ROOT_PREFIX, "-thumb-readOnly,.").concat(ROOT_PREFIX, "-thumb-disabled)"), {
  cursor: 'pointer'
}), ".".concat(ROOT_PREFIX, "-icon"), {
  '&.icon-down svg': {
    transform: 'rotate(180deg)'
  },
  '&-small': {
    fontSize: '24px',
    width: 24,
    height: 24
  },
  '&-medium': {
    fontSize: '32px',
    width: 32,
    height: 32
  },
  '&.disabled': {
    svg: {
      path: {
        fill: PROMETHEAN_NEUTRAL_DARK_GREY
      }
    }
  }
}), ".".concat(ROOT_PREFIX, "-thumb-label"), _objectSpread({}, PROMETHEAN_TYPOGRAPHY_EYEBROW))));
export var ThumbsRoot = styled('span')(_defineProperty({}, "&.".concat(ROOT_PREFIX, "-root"), _defineProperty(_defineProperty({
  display: 'inline-flex',
  columnGap: '9px',
  alignItmes: 'center',
  color: PROMETHEAN_TEXT,
  span: {
    display: 'flex',
    alignItems: 'center'
  }
}, "&-medium .".concat(ROOT_PREFIX, "-label"), {
  paddingTop: '4px',
  paddingBottom: '4px'
}), ".".concat(ROOT_PREFIX, "-label"), _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
  '&.label-left': {
    order: -1,
    paddingRight: '1px'
  },
  '&.label-right': {
    order: 0,
    paddingLeft: '1px'
  }
}))));